import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInfoSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconInfoSimple"><Path d="M12.75 18.5H15V20H9V18.5H11.25V11H9V9.5H12.75V18.5Z" fill="currentColor"/><Path d="M12 4C12.8284 4 13.5 4.67157 13.5 5.5C13.5 6.32843 12.8284 7 12 7C11.1716 7 10.5 6.32843 10.5 5.5C10.5 4.67157 11.1716 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInfoSimple;
